import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const DELETE_FILES_CLIENT_RESET = 'DELETE_FILES_CLIENT_RESET';
export const DELETE_FILES_CLIENT_LOADING = 'DELETE_FILES_CLIENT_LOADING';
export const DELETE_FILES_CLIENT_SUCCESS = 'DELETE_FILES_CLIENT_SUCCESS';
export const DELETE_FILES_CLIENT_REJECT = 'DELETE_FILES_CLIENT_REJECT';

//* ACTIONS ------------------------------------------------
export const deleteFilesClientReset = () => ({ type: DELETE_FILES_CLIENT_RESET });
export const deleteFilesClientLoading = () => ({ type: DELETE_FILES_CLIENT_LOADING });
export const deleteFilesClientSuccess = (payload) => ({ type: DELETE_FILES_CLIENT_SUCCESS, payload });
export const deleteFilesClientReject = (payload) => ({ type: DELETE_FILES_CLIENT_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const deleteFilesClientRequest = async (data = {}, getState) => {
    const options = await withToken({
        method: Methods.DELETE,
        data,
    }, getState);
    return request(`/Clients/web/DeleteClientUploadFile/${data}`, options);
};
